import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { content } from "@/content";
import { BookingProvider } from "@/BookingContext";
import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import { MethodManifesto } from "@/components/MethodManifesto";
import { ConsultingSection } from "@/components/ConsultingSection";
import { AboutLuca } from "@/components/AboutLuca";
import { Testimonials } from "@/components/Testimonials";
import { MarqueeSection } from "@/components/MarqueeSection";
import { FooterCTA, Footer } from "@/components/FooterCTA";
import { BookingModal } from "@/components/BookingModal";
import { useState } from "react";

function App() {
  const [lang, setLang] = useState("ja");
  const t = content[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const toggleLang = () => setLang((l) => (l === "ja" ? "en" : "ja"));

  return (
    <BookingProvider>
      <div className="App min-h-screen bg-[#FAFAFA] font-body text-black antialiased">
        <Navigation t={t} lang={lang} toggleLang={toggleLang} />
        <main>
          <HeroSection t={t} />
          <MarqueeSection t={t} />
          <MethodManifesto t={t} />
          <ConsultingSection t={t} />
          <AboutLuca t={t} />
          <Testimonials t={t} />
          <FooterCTA t={t} />
        </main>
        <Footer t={t} />
        <BookingModal t={t} />
      </div>
    </BookingProvider>
  );
}

export default App;
